import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { validateEmail } from '@Utils/Email';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import Input from '@Components/Input';
import Button from '@Components/Button';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import './BulkIdRegisterModal.custom.scss';
import './BulkIdRegisterModal.theme.scss';

function BulkIdRegisterModal({ isLoading, emailSubmit, onModalClosed, selfClose, closed }) {
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);

  const onSubmit = () => {
    if (isLoading) {
      return;
    }

    if (validateEmail(email)) {
      setEmailInvalid(false);
      emailSubmit(email);
    } else {
      setEmailInvalid(true);
    }
  };

  const onInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  useEffect(
    () => () => {
      onModalClosed();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <DialogsWithIcon
      size="sm"
      closed={closed}
      movable={false}
      className="react-dialogs-scrollable bulk-id-register-modal"
      headerClassName="bulk-id-register-modal__header"
      contentClassName="bulk-id-register-modal__content"
      layoutType="info"
      character="i"
      selfClose={selfClose}
      header={
        <div className="bulk-id-register-modal__header-text">
          <span>You are activating a registration ID</span>
        </div>
      }
      footer={
        <div className="els-btn-group-right">
          <Button
            onClick={selfClose}
            buttonConfig={{
              label: 'Cancel',
              type: 'link',
              size: 'sm',
              e2eName: 'bulk-id-email-cancel',
            }}
          />
          <Button
            onClick={onSubmit}
            buttonConfig={{
              label: 'Continue',
              type: 'primary',
              size: 'sm',
              e2eName: 'bulk-id-email-continue',
            }}
          />
        </div>
      }>
      <div>Validate your email account to continue with the redemption process.</div>
      <Input
        clearButton={false}
        className="bulk-id-register-modal__input"
        classNameInput="e2e-bulk-id-email-input"
        classNamePlaceholder="bulk-id-register-modal__input-placeholder"
        placeholder="Email account"
        autofocus
        debounceDela={0}
        value={email}
        onChange={setEmail}
        inputProps={{ onKeyDown: onInputKeyDown }}
        validationMessage={emailInvalid && 'Incorrect email address'}
      />
      {isLoading && <SimpleSpinner />}
    </DialogsWithIcon>
  );
}

BulkIdRegisterModal.propTypes = {
  isLoading: PropTypes.bool,
  emailSubmit: PropTypes.func.isRequired,
  onModalClosed: PropTypes.func.isRequired,
  selfClose: PropTypes.func.isRequired,
  closed: PropTypes.bool,
};

export default BulkIdRegisterModal;
